export default __webpack_public_path__ + "static/media/hidraulic25.a4178b3c.jpeg";